
import React from 'react';

export const PencilSquareIcon: React.FC<{ className?: string }> = ({ className }) => (
  <span className={`material-symbols-outlined ${className}`}>
    edit
  </span>
);